import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-missing-configuration-job',
  standalone: false,
  templateUrl: './missing-configuration-job.component.html',
  styleUrls: ['./missing-configuration-job.component.scss']
})
export class MissingConfigurationJobComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
